import $api from "@/frontend/shared/api/axios";
import { createCommonFilter } from "../../lib/createCommonFilter";
import { TStageShortInfo } from "../types/types";

export async function getStagesNameData({
  trueColumnFilters,
  pipelineId
}: {
  trueColumnFilters: { latestFundingRound?: string[]; locations?: string[]; tagNames?: string[] };
  pipelineId: number;
}) {
  const params = new URLSearchParams();

  const { commonFilter, filterAdded } = createCommonFilter(trueColumnFilters);

  if (filterAdded) {
    params.append("commonFilter", JSON.stringify(commonFilter));
  }

  params.append("pipelineId", pipelineId.toString());

  const response = await $api.get<{ data: { stages: TStageShortInfo[] } }>(`/stages?addCompanies=false`, { params });
  return response.data.data;
}
